import { RouteConfig } from "vue-router";

const myPage = () => import("@/views/pages/myPage.vue");
const AdminLayout = () => import("@/views/layouts/admin/qMaster.vue");
const MasterPage = () => import("@/views/pages/master.vue");
const FloorListPage = () => import("@/views/pages/floor/floorList.vue");
const FloorEditPage = () => import("@/views/pages/floor/floorEdit.vue");
const PropertyListPage = () => import("@/views/pages/property/propertyList.vue");
const PropertyEditPage = () => import("@/views/pages/property/propertyEdit.vue");
const PropertyBulkEditPage = () => import("@/views/pages/property/propertyBulkEdit.vue");
const PartnerListPage = () => import("@/views/pages/partner/partnerList.vue");
const AccountListPage = () => import("@/views/pages/account/accountList.vue");
const RepairContentListPage = () => import("@/views/pages/repair-content/repairContent.vue");
const dashboardPage = () => import("@/views/pages/dashboard/dashboard.vue");
const contractListPage = () => import("@/views/pages/contract/contractList.vue");
const contractEditPage = () => import("@/views/pages/contract/contractEdit.vue");
const contractMoveOutPage = () => import("@/views/pages/contract/contractMoveOut.vue");
const contractMoveOutFollowPage = () => import("@/views/pages/contract-moving/contractMovingFollow.vue");
const contractMovingListPage = () => import("@/views/pages/contract-moving/contractMovingList.vue");
const companyInformationPage = () => import("@/views/pages/company/companyInformation.vue");

import { USER_TYPE } from "@/model/user";

const adminRouter: Array<RouteConfig> = [
  {
    path: "/admin",
    name: "admin",
    component: AdminLayout,
    meta: {
      allowRole: [USER_TYPE.STAFF],
    },
    children: [
      {
        path: "/not-found",
        name: "not-found",
        component: () => import("@/views/pages/notFound.vue"),
      },
      {
        path: "dashboard",
        name: "admin.dashboard",
        component: dashboardPage,
        meta: {
          pageTitle: "J-SYSTEM | ダッシュボード",
          title: "J-SYSTEM | ダッシュボード",
          subTitle: "J-SYSTEM | ダッシュボード",
          className: "DB",
          permission: ['view', 'Dashboard'],
        },
      },
      {
        path: "my-page",
        name: "my-page",
        component: myPage,
        meta: {
          pageTitle: "J-SYSTEM | マイページ",
          title: "J-SYSTEM | マイページ",
          subTitle: "J-SYSTEM | マイページ",
          className: "Admin",
          permission: ['view', 'MyPage'],
        },
      },
      {
        path: "master",
        name: "admin.master",
        component: MasterPage,
        meta: {
          pageTitle: "J-SYSTEM | マスター管理",
          title: "J-SYSTEM | マスター管理",
          subTitle: "J-SYSTEM | マスター管理",
          className: "Mnt_MS",
          permission: ['view', 'Master']
        },
      },
      {
        path: "",
        name: "admin.floor-router",
        component: {
          // Inline declaration of a component that renders our <router-view>
          render: (c) => c('router-view'),
        },
        children: [
          {
            path: "floor",
            name: "admin.floor",
            component: FloorListPage,
            meta: {
              pageTitle: "J-SYSTEM | 間取り管理",
              title: "J-SYSTEM | 間取り管理",
              subTitle: "J-SYSTEM | 間取り管理",
              className: "Mnt_MD",
              permission: ['list', 'FloorPlan']
            },
          },
          {
            path: "floor/edit/:id",
            name: "admin.floor-edit",
            component: FloorEditPage,
            meta: {
              pageTitle: "J-SYSTEM | 間取り登録",
              title: "J-SYSTEM | 間取り登録",
              subTitle: "J-SYSTEM | 間取り登録",
              className: "Mnt_MD",
              permission: ['edit', 'FloorPlan']
            },
          },
          {
            path: "floor/create",
            name: "admin.floor-create",
            component: FloorEditPage,
            meta: {
              pageTitle: "J-SYSTEM | 間取り登録",
              title: "J-SYSTEM | 間取り登録",
              subTitle: "SYS | 間取り登録",
              className: "Mnt_MD",
              permission: ['add', 'FloorPlan']
            },
          },
        ],
      },
      {
        path: "",
        name: "admin.property-router",
        component: {
          // Inline declaration of a component that renders our <router-view>
          render: (c) => c('router-view'),
        },
        children: [
          {
            path: "property",
            name: "admin.property",
            component: PropertyListPage,
            meta: {
              pageTitle: "J-SYSTEM | 物件管理",
              title: "J-SYSTEM | 物件管理",
              subTitle: "J-SYSTEM | 物件管理",
              className: "Mnt_PR",
              permission: ['list', 'Property']
            },
          },
          {
            path: "property/create",
            name: "admin.property-create",
            component: PropertyEditPage,
            meta: {
              pageTitle: "J-SYSTEM | 物件詳細",
              title: "J-SYSTEM | 物件詳細",
              subTitle: "J-SYSTEM | 物件詳細",
              className: "Mnt_PR",
              permission: ['add', 'Property']
            },
          },
          {
            path: "property/edit/:id",
            name: "admin.property-edit",
            component: PropertyEditPage,
            meta: {
              pageTitle: "J-SYSTEM | 物件詳細",
              title: "J-SYSTEM | 物件詳細",
              subTitle: "J-SYSTEM | 物件詳細",
              className: "Mnt_PR",
              permission: ['edit', 'Property']
            },
          },
          {
            path: "property/detail/:id",
            name: "admin.property-detail",
            component: PropertyEditPage,
            meta: {
              pageTitle: "J-SYSTEM | 物件詳細",
              title: "J-SYSTEM | 物件詳細",
              subTitle: "J-SYSTEM | 物件詳細",
              className: "Mnt_PR",
              permission: ['view', 'Property']
            },
          },
          {
            path: "property/bulk",
            name: "admin.property-bulk-edit",
            component: PropertyBulkEditPage,
            meta: {
              pageTitle: "J-SYSTEM | 物件一括編集",
              title: "J-SYSTEM | 物件一括編集",
              subTitle: "J-SYSTEM | 物件一括編集",
              className: "Mnt_PR",
              permission: ['bulk-edit', 'Property']
            },
          },
        ],
      },
      {
        path: "partner",
        name: "admin.partner",
        component: PartnerListPage,
        meta: {
          pageTitle: "J-SYSTEM | パートナー管理",
          title: "J-SYSTEM | パートナー管理",
          subTitle: "J-SYSTEM | パートナー管理",
          className: "Mnt_PN",
          permission: ['view', 'Partner']
        },
      },
      {
        path: "account",
        name: "admin.account",
        component: AccountListPage,
        meta: {
          pageTitle: "J-SYSTEM | アカウント管理",
          title: "J-SYSTEM | アカウント管理",
          subTitle: "J-SYSTEM | アカウント管理",
          className: "Mnt_AC",
          permission: ['view', 'Account']
        },
      },
      {
        path: "repair-content",
        name: "admin.repair-content",
        component: RepairContentListPage,
        meta: {
          pageTitle: "J-SYSTEM | 修繕一覧",
          title: "J-SYSTEM | 修繕一覧",
          subTitle: "J-SYSTEM | 修繕一覧",
          className: "Mnt_RP",
          permission: ['list', 'RepairContent']
        },
      },
      {
        path: "",
        name: "admin.contract-router",
        component: {
          // Inline declaration of a component that renders our <router-view>
          render: (c) => c('router-view'),
        },
        children: [
          {
            path: "contract",
            name: "admin.contract",
            component: contractListPage,
            meta: {
              pageTitle: "J-SYSTEM | 契約管理",
              title: "J-SYSTEM | 契約管理",
              subTitle: "J-SYSTEM | 契約管理",
              className: "Mnt_CT",
              permission: ['list', 'Contract']
            },
          },
          {
            path: "contract/add",
            name: "admin.contract-add",
            component: contractEditPage,
            meta: {
              pageTitle: "J-SYSTEM | 契約管理",
              title: "J-SYSTEM | 契約管理",
              subTitle: "J-SYSTEM | 契約管理",
              className: "Mnt_CT",
              permission: ['add', 'Contract']
            },
          },
          {
            path: "contract/edit/:id",
            name: "admin.contract-edit",
            component: contractEditPage,
            meta: {
              pageTitle: "J-SYSTEM | 契約管理",
              title: "J-SYSTEM | 契約管理",
              subTitle: "J-SYSTEM | 契約管理",
              className: "Mnt_CT",
              permission: ['edit', 'Contract']
            },
          },
        ],
      },
      {
        path: "",
        name: "admin.contract-moving-router",
        component: {
          // Inline declaration of a component that renders our <router-view>
          render: (c) => c('router-view'),
        },
        children: [
          {
            path: "contract-moving",
            name: "admin.contract-moving",
            component: contractMovingListPage,
            meta: {
              pageTitle: "J-SYSTEM | 退去管理",
              title: "J-SYSTEM | 退去管理",
              subTitle: "J-SYSTEM | 退去管理",
              className: "Mnt_LV",
              permission: ['list', 'ContractMoving']
            },
          },
          {
            path: "contract/move-out/:id",
            name: "admin.contract-move-out",
            component: contractMoveOutPage,
            meta: {
              pageTitle: "J-SYSTEM | 退去申請情報",
              title: "J-SYSTEM | 退去申請情報",
              subTitle: "J-SYSTEM | 退去申請情報",
              className: "Mnt_CT",
              permission: ['move-out', 'Contract']
            },
          },
          {
            path: "contract/move-out-follow/:id",
            name: "admin.contract-move-out-follow",
            component: contractMoveOutFollowPage,
            meta: {
              pageTitle: "J-SYSTEM | 退去管理",
              title: "J-SYSTEM | 退去管理",
              subTitle: "SYS | 退去管理",
              className: "Mnt_LV",
              permission: ['move-out-follow', 'ContractMoving']
            },
          },
        ],
      },
      {
        path: "message",
        name: "admin.message",
        component: () => import("@/views/pages/message/messageLayout.vue"),
        meta: {
          pageTitle: "J-SYSTEM | トークルーム",
          title: "J-SYSTEM | トークルーム",
          subTitle: "J-SYSTEM | トークルーム",
          className: "Mnt_TR",
          permission: ['list', 'Message']
        },
      },
      {
        path: "company",
        name: "admin.company",
        component: companyInformationPage,
        meta: {
          pageTitle: "J-SYSTEM | 会社情報",
          title: "J-SYSTEM | 会社情報",
          subTitle: "J-SYSTEM | 会社情報",
          className: "Mnt_CM",
          permission: ['view-info', 'Company']
        },
      },
    ],
  },
];

export default adminRouter;
